import React from 'react'
import { Head, Redirect } from 'react-static'
import styled from 'styled-components'

import { database, authorize, auth } from '../../firebase'
import { publish } from '../../webhooks'

import Loading from '../common/Loading'
import AdminContent from './AdminContent'
import AdminSidebar from './AdminSidebar'
import AdminEdit from './AdminEdit'
import AdminCreate from './AdminCreate'
import AdminRemove from './AdminRemove'

const Wrapper = styled.div`
  font-family: 'Overpass', sans-serif !important;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  position: relative;

  p.menu-label {
    color: ${props => props.theme.main.hover};
  }

  ul.menu-list {
    a {
      color: #fff;

      &:hover {
        background-color: ${props => props.theme.admin.info};
        color: #fff;
      }

      &.is-active {
        background-color: transparent;
        font-weight: bold;
      }
    }

    .sub-menu {
      display: none;
    }

    .current .sub-menu {
      display: block;
    }
  }
`

const Content = styled.div`
  .admin-page &.column {
    padding: 50px;

    .title.is-3 {
      margin-bottom: 1em;
    }

    .admin-content,
    .admin-create,
    .admin-edit {
      max-width: 60em;
    }

    .box {
      display: flex;

      .admin-item-title {
        span {
          margin-right: 1em;
        }

        strong {
          margin-right: 1em;
          text-transform: capitalize;
        }
      }
    }

    .content ul {
      margin-left: 0;
    }

    .title,
    .subtitle {
      text-transform: capitalize;
    }

    .gallery-list {
      padding: 0 0 2em 0;

      &:last-child {
        padding: 0;
      }
    }

    .admin-item-title {
      span,
      strong {
        margin: 0.3em 0;
      }

      span {
        display: block;

        @media screen and (min-width: 600px) {
          display: inline-block;
        }
      }
    }

    .admin-item.box {
      display: block;

      strong {
        display: inline-block;
        vertical-align: middle;
      }

      @media screen and (min-width: 450px) {
        display: flex;
      }
    }

    .admin-item .field {
      margin-top: 1.2em;

      @media screen and (min-width: 450px) {
        margin-top: 0;
      }
    }

    @media screen and (min-width: 769px) {
      min-height: 33em;
      padding-left: calc(18em + 50px);
    }
  }
`
export default class Admin extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      current: props.match.url.split('/')[2],
      data: null,
      editData: null,
      template: null,
      refUrl: null,
      status: 'default',
      itemTitle: null,
      signoutRedirect: false,
    }
    this.data = []
    this.authenticateUser = this.authenticateUser.bind(this)
    this.retrieveData = this.retrieveData.bind(this)
    this.updateData = this.updateData.bind(this)
    this.resetDataOrder = this.resetDataOrder.bind(this)
    this.signout = this.signout.bind(this)
    this.redirect = this.redirect.bind(this)
    this.edit = this.edit.bind(this)
    this.create = this.create.bind(this)
    this.remove = this.remove.bind(this)
    this.mounted = null
    this.ref = database.ref('latest/')
  }

  componentWillMount() {
    this.mounted = true
    this.authenticateUser()
  }

  componentWillUnmount() {
    this.mounted = false
    this.ref.off()
  }

  authenticateUser() {
    authorize.onAuthStateChanged(user => (user ? this.retrieveData() : this.redirect()))
  }

  retrieveData() {
    if (!this.mounted) return
    const { current } = this.state

    switch (current) {
      case 'listen':
        this.ref = database.ref(`${current}/`).orderByChild('order')
        break
      default:
        this.ref = database.ref(`${current}/`)
    }

    this.ref.on('child_added', res => {
      if (!this.mounted) return
      this.data.push(res)
      this.setState({ data: this.data })
    })
    this.ref.on('child_changed', res => {
      if (!this.mounted) return
      if (current === 'listen') {
        return this.updateData()
      }

      for (let i = 0, l = this.data.length; i < l; i++) {
        if (this.data[i].key === res.key) {
          this.data[i] = res
        }
      }
      this.setState({ data: this.data })
    })
    this.ref.on('child_removed', res => {
      if (!this.mounted) return

      if (current === 'listen') {
        return this.resetDataOrder()
      }

      for (let i = 0, l = this.data.length; i < l; i++) {
        const currentKey = this.data[i].key
        const removedKey = res.key
        if (currentKey === removedKey) {
          this.data.splice(i, 1)
        }
      }
      this.setState({ data: this.data })
    })
  }

  updateData() {
    database
      .ref(`${this.state.current}/`)
      .orderByChild('order')
      .once('value')
      .then(items => {
        this.data = []
        items.forEach(item => {
          this.data.push(item)
        })
        this.setState({ data: this.data })
      })
  }

  resetDataOrder() {
    const ref = database.ref(`${this.state.current}/`)
    ref
      .orderByChild('order')
      .once('value')
      .then(items => {
        this.data = []
        let i = 0
        items.forEach(item => {
          this.data.push(item)
          ref.child(`${item.key}/order`).set(i)
          i += 1
        })
        this.setState({ data: this.data })
      })
  }

  signout() {
    auth.signout(this.redirect)
  }

  redirect() {
    if (!this.mounted) return
    this.setState({ signoutRedirect: true })
  }

  edit(ref, template) {
    this.setState({
      status: 'editing',
      editData: null,
    })
    const urlPieces = ref.path.pieces_
    const url = urlPieces.reduce((a, b) => `${a}/${b}`)
    const data = database.ref(url)
    data.once('value').then(snapshot => {
      this.setState({
        editData: snapshot,
        template,
        refUrl: url,
      })
    })
  }

  remove(ref, template, title) {
    this.setState({ status: 'deleting' })
    const urlPieces = ref.path.pieces_
    const url = urlPieces.reduce((a, b) => `${a}/${b}`)
    this.setState({
      refUrl: url,
      template,
      itemTitle: title,
    })
  }

  create(template) {
    this.setState({
      status: 'creating',
      template,
    })
  }

  render() {
    const { current, data, editData, template, refUrl, status, itemTitle, signoutRedirect } =
      this.state
    return signoutRedirect ? (
      <Redirect push to="/login" />
    ) : (
      <Wrapper className="admin-page">
        <div className="columns">
          <Head>
            <title>Admin</title>
            <meta name="robots" content="noindex" />
          </Head>
          <AdminSidebar
            data={data}
            create={this.create}
            signout={this.signout}
            current={current}
            publish={publish}
          />
          <Content className="column is-white">
            {status === 'default' && (
              <AdminContent data={data} current={current} remove={this.remove} edit={this.edit} />
            )}
            {status === 'editing' && (
              <div>
                {editData !== null ? (
                  <AdminEdit data={editData} template={template} refUrl={refUrl} />
                ) : (
                  <Loading color="#ff486a" />
                )}
              </div>
            )}
            {status === 'creating' && (
              <div>
                <AdminCreate template={template} refUrl={refUrl} data={data} />
              </div>
            )}
            {status === 'deleting' && (
              <div>
                <AdminRemove itemTitle={itemTitle} refUrl={refUrl} template={template} />
              </div>
            )}
          </Content>
        </div>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/Admin.js